<nb-card *appPermissionCheck="ComponentPermission.DASHBOARD_OVERVIEW">
  <nb-card-header class='ml-2'>
    Dashboard Overview
  </nb-card-header>

  <nb-card-body>
    <ngx-prospect-overview></ngx-prospect-overview>
  </nb-card-body>
</nb-card>
